export class DrawingScale {
  drawWidth: number;
  drawHeight: number;
  actualWidth: number;
  actualHeight: number;
  scale: number;
  xClipping: number;

  get scaleWidth(): number {
    return this.actualWidth / this.drawWidth;
  }

  get scaleHeight(): number {
    return this.actualHeight / this.drawHeight;
  }
};
